// A component filed under a name that isn't on the managed list (his call, 26 Oct): it keeps its own name, can be
// marked like any other, and says plainly that an admin still has to approve it or merge it into a listed one.
export const PendingComponentBadge = ({ show, testid }) => (show ? (
  <span data-testid={testid}
    className="inline-flex items-center rounded-full border border-[#E0781A]/50 bg-orange-50 px-2 py-0.5 text-[10px] font-bold text-[#C76714] whitespace-nowrap">
    new component — waiting for approval
  </span>
) : null);
